import { Skeleton } from '@radix-ui/themes';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Accordion } from 'radix-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ActivityLogSkeleton = () => {
  const { t } = useTranslation();
  const [accordionSelected, setAccordionSelected] = useState<string>();
  return (
    <div className="activity-log">
      <Accordion.Root type="single" defaultValue="activity" collapsible onValueChange={setAccordionSelected}>
        <Accordion.Item value="activity">
          <Accordion.Header>
            <Accordion.Trigger className="font-bold w-full" style={{ all: 'unset' }}>
              <span className="clickable flex justify-between">
                <span>{t('swiper.activityLog.activityHeader')}</span>
                {accordionSelected === 'activity' ? <ChevronUp /> : <ChevronDown />}
              </span>
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="accordion-content">
            <div>
              <div className="flex align-middle">
                <div className="float-left">
                  <Skeleton width="1.4rem" height="1.4rem" style={{ borderRadius: '50%' }} />
                </div>
                <div className="w-full ml-1">
                  <Skeleton width={'100%'} height="1.2rem" />
                </div>
              </div>
            </div>
            <div>
              <div className="flex align-middle">
                <div className="float-left">
                  <Skeleton width="1.4rem" height="1.4rem" style={{ borderRadius: '50%' }} />
                </div>
                <div className="w-full ml-1">
                  <Skeleton width={'100%'} height="1.2rem" />
                </div>
              </div>
            </div>
          </Accordion.Content>
        </Accordion.Item>
        <Accordion.Item value="email">
          <Accordion.Header>
            <Accordion.Trigger className="font-bold w-full" style={{ all: 'unset' }}>
              <span className="clickable flex justify-between">
                <span>{t('swiper.activityLog.communicationsHeader')}</span>
                {accordionSelected === 'email' ? <ChevronUp /> : <ChevronDown />}
              </span>
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="accordion-content">
            <div>
              <div className="flex align-middle ">
                <div className="float-left">
                  <Skeleton width="1.4rem" height="1.4rem" style={{ borderRadius: '50%' }} />
                </div>
                <div className="w-full ml-1">
                  <Skeleton width={'100%'} height="1.2rem" />
                </div>
              </div>
            </div>
            <div>
              <div className="flex align-middle ">
                <div className="float-left">
                  <Skeleton width="1.4rem" height="1.4rem" style={{ borderRadius: '50%' }} />
                </div>
                <div className="w-full ml-1">
                  <Skeleton width={'100%'} height="1.2rem" />
                </div>
              </div>
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
      <div className="previus-applications my-4">
        <h2>{t('swiper.activityLog.previousApplications')}</h2>
        <div className="user-select-none">
          <Skeleton className="mb-1" />
          <Skeleton className="mb-1" />
          <Skeleton />
        </div>
      </div>
    </div>
  );
};

export default ActivityLogSkeleton;
